import { _get, _put } from "../../../../http";

// variables de conversión de monedas
export const getVariablesConversionMonedasDistribucion = (distribucionId) =>
  _get(`/distribuciones/${distribucionId}/variablesDeConversionDeMonedas`);

export const putVariablesConversionMonedasDistribucion = (distribucionId, body) =>
  _put(`/distribuciones/${distribucionId}/variablesDeConversionDeMonedas`, body);
